export enum NotificationSource {
  Zendesk = 'zendesk',
  Billing = 'billing',
  Subscription = 'subscription',
}
